import { Autocomplete, Button, Paper, Text, Box, Group, Flex } from '@mantine/core'
import classes from './MaterialSubType.module.css';
import { IoAdd } from "react-icons/io5";
import { IoMdSearch } from "react-icons/io";

import React, { memo, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import TableMaterialSubTypeComponent from './TableMaterialSubType.component';
import InputButton from '../../../CustomComponent/InputFileButton/Inputbutton.component';
import { baseUrl } from '../../../Constants/constant';
import SampleFile from '../../../CustomComponent/DownloadSampleFile/Samplefile.component';

const MaterialSubTypeComponent = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [sendsearch, setSendsearch] = useState('');

  const handlechange = (value: any) => {
    setSearch(value);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSendsearch(search);
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <>

      <Paper shadow="xs" p="xs" radius="md">
        <Box>
          <Flex
           style={{justifyContent:'space-between'}}
           align="center"
           >
            <Box>
              <Text ta="left">Raw Material Sub Type</Text>
            </Box>
            <Group>
              <Autocomplete
                // label="Your favorite library"
                value={search}
                onChange={handlechange}
                placeholder="Search by Material-Sub-Type"
                leftSection={<IoMdSearch />}
              />

              <Button
                className={classes.addbtn}
                variant="gradient"
                gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                leftSection={<IoAdd size={20} />}
                onClick={() => navigate('/material-subtype/addmaterial-subtype')}
              >
                Add Raw Material Sub
              </Button>
              <InputButton
                url={`${baseUrl}admin/raw-material-sub-types/import-file`}
              />
              <SampleFile type={'rawmaterialSubType'} />
            </Group>
          </Flex>
          <TableMaterialSubTypeComponent editLink={'/material-subtype/addmaterial-subtype'} search={sendsearch} />
        </Box>
      </Paper>
    </>
  )
}

export default memo(MaterialSubTypeComponent)
